import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { ButtonComponent, HeadlineComponent, TextComponent } from '@zeiss/beyond-online-angular';
import { IconComponent, PopUpRef } from 'vis-ods-angular';
import { RoutesEnum } from '../../../routing/routes.enum';
import { ConfigurationStore } from '../../../state-management/stores/configuration.store';

@Component({
	selector: 'app-single-order-submit-success-popup',
	imports: [TranslocoModule, IconComponent, HeadlineComponent, TextComponent, ButtonComponent],
	templateUrl: './single-order-submit-success-popup.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SingleOrderSubmitSuccessPopupComponent {
	private readonly router = inject(Router);
	private readonly popUpRef = inject(PopUpRef);
	private readonly $settings = inject(ConfigurationStore).settings;

	goToNewOrder() {
		this.router.navigate([RoutesEnum.order]);
		this.popUpRef.close();
	}

	goToMyZeiss() {
		window.location.href = this.$settings()?.myorders_link || '';
	}
}
